function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Responsive from 'react-responsive';
export var Desktop = function Desktop(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: 769
  }));
};
export var DesktopTri = function DesktopTri(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: 1025
  }));
};
export var DesktopAndTablet = function DesktopAndTablet(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: 481
  }));
};
export var DesktopAndTabletLast = function DesktopAndTabletLast(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: 641
  }));
};
export var Tablet = function Tablet(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: 481,
    maxWidth: 768
  }));
};
export var TabletLast = function TabletLast(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: 641,
    maxWidth: 768
  }));
};
export var Mobile = function Mobile(props) {
  return React.createElement(Responsive, _extends({}, props, {
    maxWidth: 480
  }));
};
export var MobileFirst = function MobileFirst(props) {
  return React.createElement(Responsive, _extends({}, props, {
    maxWidth: 640
  }));
};
export var MobileAndTablet = function MobileAndTablet(props) {
  return React.createElement(Responsive, _extends({}, props, {
    maxWidth: 768
  }));
};
export var MobileAndTabletTri = function MobileAndTabletTri(props) {
  return React.createElement(Responsive, _extends({}, props, {
    maxWidth: 1024
  }));
};
export var Default = function Default(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: 481
  }));
};
export default Responsive;